import React, { memo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//components
import { Candidature } from "@uaveiro/ui";
//Utils
import { compose } from "../../services/utilities";
//API
import { getCourseAdmissionById } from "../../api/requests";

const CandidatureTemplate = memo(function CandidatureTemplate({
  history,
  match,
  ...props
}) {
  const [state, setState] = useState({
    loading: true,
    error: false,
    content: {}
  });

  const onFetchContent = async () => {
    try {
      const { lang, id } = match.params;
      const data = await getCourseAdmissionById({
        id,
        lang,
        hasDelay: true,
        history
      });

      setState(prevState => {
        return { ...prevState, content: { ...data }, loading: false };
      });
    } catch (error) {
      setState(prevState => {
        return { ...prevState, loading: false, error: true };
      });
    }
  };

  //If the user changes the url update the content
  useEffect(() => {
    onFetchContent();
  }, [history.location]);

  return (
    <Candidature
      content={state.content}
      loading={state.loading}
      hasError={state.error}
      {...props}
    />
  );
});

CandidatureTemplate.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object
};

export default compose(withRouter)(CandidatureTemplate);
